import dataManager from "./dataManager";

export default function miniTable(api, limit = 5) {
  return dataManager(
    "results",
    async props => {
      const response = await api(props, { limit });
      return response.data.results;
    },
    []
  );
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/miniTable.jsx